import React from 'react';
import t from '../../../lib/I18n';
import Radio from '../../form/Radio';
import PropTypes from 'prop-types';

const RadioGroups = ({
    name,
    title,
    i18nPrefix,
    options,
    seatingPreferences,
    handleSeatingPreferenceChange,
}) => {
    return (
        <div className="seat-container__item">
            <div className="seat-container__item--title">{title}</div>
            <div className="radio-row">
                {options.map(({ value, key }) => (
                    <Radio
                        key={value}
                        name={name}
                        value={value}
                        label={t(`${i18nPrefix}.${key}`)}
                        checked={seatingPreferences.get(name) === value}
                        onChange={handleSeatingPreferenceChange(name)}
                    />
                ))}
            </div>
        </div>
    );
};

RadioGroups.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    i18nPrefix: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    seatingPreferences: PropTypes.object.isRequired,
    handleSeatingPreferenceChange: PropTypes.func.isRequired,
};

export default RadioGroups;
